//importing whole set
import * as icons from "@coreui/icons";

import { logo } from "./logo";

export const iconsSet = Object.assign({}, { logo }, icons);
